var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264D61;stroke:#264D61;stroke-width:25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.5,303.5h102.9c5.4,0,10.2,21.5,11.9,26.7c2.3,7.4,7,17.6,16.4,26.5c18,17,40,16.8,44.4,16.7 c4.6-0.2,23.9-1.5,40-17.3c16.2-15.8,18-35.2,18.2-39.8c0.4-5.6,0.6-20.4-8.6-35.5c-7-11.5-16.2-17.7-21-20.6 c-0.3-0.2-1.9-1.4-2.1-3.6c-0.2-1.8,0.6-3.5,2.1-4.6c4.8-2.9,14.9-9.9,22.2-23c7.5-13.6,7.9-26.3,7.7-31.9c-0.2-4-2-27.7-22.2-44.4 c-16.7-13.8-35.4-14.1-40.5-14c-5.8,0.2-20,1.6-33.9,11.7c-12,8.7-18.2,19.8-21.3,27.6c-1.9,4.8-6.5,26.9-11.6,26.9H202.8 c-5.2,0-9.8-22.1-11.6-26.9c-2.5-6.6-7.1-15.3-15.6-23.1c-15.9-14.7-34.4-15.9-39.5-16.1c-4-0.1-27.7-0.1-45.8,18.9 c-15.1,15.8-16.6,34.5-16.8,39.5c-0.2,5.8,0.1,20,9.1,34.6c6.9,11.1,15.7,17.4,20.6,20.3c0.1,0.1,2.3,1.5,2.3,4.2 c0,2.5-2.1,3.9-2.3,4c-4.9,3-13.9,9.2-20.8,20.6c-9.2,15-9.2,29.8-8.9,35.5c0.4,5.9,2.3,20.7,13.3,34.4 c16.6,20.6,41,22.4,45.1,22.7c4.4,0.2,23.9,0.7,41.4-13.8c11.5-9.5,16.8-21.1,19.3-29.2C194.2,325.1,199,303.5,204.5,303.5 L204.5,303.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnack);
export default __webpack_public_path__ + "static/media/snack.e694633af812b85ac96165df856fcb0b.svg";
export { ForwardRef as ReactComponent };